import CartSmsManagement from "./CartSmsManagement";
import SmsTemplatePage from "./SmsTemplates";
import SmsVariablesModal from "../../../Modals/sms-variables";
import { useEffect, useState } from "react";
import { settingDetails } from "../../../../stores/actions/settings.actions.types";
import { connect } from "react-redux";
import { FaPlus } from "react-icons/fa";
import { BiLoaderAlt } from "react-icons/bi";

const AllSMSManagement = ({ settingDetails }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [setting, setSetting] = useState(null);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    settingDetails({
      callback: (data) => {
        if (data?.success) {
          setSetting(data?.data?.setting);
          setLoading(false);
        }
      },
    });
  }, [settingDetails, reload]);

  if (loading || !setting) {
    return (
      <div className='flex m-6 dark:bg-boxdark rounded-[10px] bg-white items-center justify-center min-h-96'>
        <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
      </div>
    );
  }

  return (
    <div>
      <SmsVariablesModal
        setting={setting}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        reload={reload}
        setReload={setReload}
      />
      <SmsTemplatePage
        reload={reload}
        setReload={setReload}
        setting={setting}
      />
      <CartSmsManagement
        reload={reload}
        setReload={setReload}
        setting={setting}
        setLoading={setLoading}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, {
  settingDetails,
})(AllSMSManagement);
